import React, { useEffect } from 'react';
import './BottomSheet.css';

const BottomSheet = ({ isOpen, onClose, onTakePhoto, onChooseFromGallery }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="bottom-sheet-overlay" onClick={onClose}>
      <div className="bottom-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="bottom-sheet-handle"></div>
        
        <div className="bottom-sheet-content">
          <button 
            className="bottom-sheet-button primary"
            onClick={onTakePhoto}
          >
            Take Photo
          </button>
          
          <button 
            className="bottom-sheet-button secondary"
            onClick={onChooseFromGallery}
          >
            Choose from Gallery
          </button>
          
          <button 
            className="bottom-sheet-button cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
